import React, { Fragment, useState, useEffect } from "react";
import { Card, Form, Spinner, Button } from "react-bootstrap";
import {  useLocation, useParams } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";


const SecondaryMarketTransactions = () => {
  const location = useLocation();
  const { getRequest } = useRequests();

  const [transactions, setTransactions] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

 

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [loading, setLoading] = useState(true);

  const fetchTransactions = async () => {
    const response = await getRequest(`transactions`); // Replace "users" with the appropriate API endpoint
    if (response && response.code === 200) {
        const filteredTransactions = response.data.filter(
        (transaction) => transaction.r_u_id != 0
        ); 
      setTransactions(filteredTransactions);
    } else {
      console.error("Failed to fetch users transactions:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: response.message,
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  useEffect(() => {
    fetchTransactions();
    if (location.state && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      setLoading(false);
    }
  }, []);

  // Filter users based on the search query
  const filteredTransactions = transactions.filter((transaction) => {
    const phone = `${transaction.phone}`.toLowerCase();
    const resellerphone = `${transaction.reseller_phone}`.toLowerCase();
    const fullName = `${transaction.first_name? transaction.first_name +" "+transaction.last_name : "N/A"}`.toLowerCase();
    const resellername = `${transaction.reseller_first_name? transaction.reseller_first_name +" "+transaction.reseller_last_name : "N/A"}`.toLowerCase();
    const event = `${transaction.name}`.toLowerCase();
    const duration = `${transaction.duration} day`;
    const quantity = `${transaction.quantity}`;
    const type = `${transaction.type}`.toLowerCase();
    const price = `${transaction.price}`.toLowerCase();
    const organizerfees = `${transaction.organizerfees}`.toLowerCase();

    let TicketDate;
    if(transaction.duration == "1"){
      TicketDate = transaction.event_ticket_date;
    }else{
      TicketDate = transaction.start_datetime;
    }
    const ticketdate = new Date(TicketDate);
    const formattedticketDate = ticketdate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const ticket_date = `${formattedticketDate}`;

    const date = new Date(transaction.created_at);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const transaction_date = `${formattedDate}`;
    const payment_id = `${transaction.payment_id}`.toLowerCase();

    const searchLower = searchQuery.toLowerCase();
  
    return ticket_date.includes(searchQuery) || fullName.includes(searchQuery) ||resellername.includes(searchQuery) || quantity.includes(searchQuery) || resellerphone.includes(searchQuery) || phone.includes(searchQuery) || organizerfees.includes(searchQuery) || price.includes(searchLower) || transaction_date.includes(searchQuery) || event.includes(searchLower) || duration.includes(searchLower) || type.includes(searchLower) || payment_id.includes(searchQuery);
  });




  const columns = [
    {
      name: "Full Name",
      selector: (row) => `${row.first_name? row.first_name +" "+row.last_name : "N/A"}`,
      sortable: true,
      width: "200px" 
    },
    {
        name: "Mobile number",
        selector: (row) => `${row.phone}`,
        sortable: true,
        width: "200px" 
    },
    {
      name: "Reseller Full Name",
      selector: (row) => `${row.reseller_first_name? row.reseller_first_name +" "+row.reseller_last_name : "N/A"}`,
      sortable: true,
      width: "200px" 
    },
    {
        name: "Reseller Mobile Number",
        selector: (row) => `${row.reseller_phone}`,
        sortable: true,
        width: "200px" 
    },
    {
      name: "Event",
      selector: (row) => `${row.name}`,
      sortable: true,
      width: "150px" 
    },
    {
        name: "Duration",
        selector: (row) => `${row.duration} day`,
        sortable: true,
        width: "200px" 
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
    },
    {
      name: "No. of Tickets",
      selector: (row) => `${row.quantity}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Seat Number",
      selector: (row) => `${row.is_seats_required === "Yes" ? row.seat_number : "-"}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Price",
      selector: (row) => row.price,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Fee",
      selector: (row) => row.organizerfees,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Date",
      selector: (row) => {
        const date = new Date(row.created_at);
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${formattedDate}`;
      },
      sortable: true,
      width: "150px" 
    },
    {
      name: "Event Date",
      selector: (row) => {
        let date;
        if(row.duration == "1"){
          date = new Date(row.event_ticket_date);
        }else{
          date = new Date(row.start_datetime);
        }
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${formattedDate}`;
      },
      sortable: true,
      width: "150px" 
    },
    {
      name: "Payment Id",
      selector: (row) => row.payment_id,
      sortable: true,
      width: "150px" 
    },
    
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headCells: {
      style: {
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
      },
    },
    pagination: {
      style: {
        fontSize: "16px",
      },
    },
  };

  const csvHeaders = [
    { label: "Mobile Number", key: "phone" },
    { label: "Reseller Mobile Number", key: "resellerPhone" },
    { label: "Event", key: "name" },
    { label: "Duration", key: "duration" },
    { label: "Type", key: "ticket_type" },
    { label: "No. of Tickets", key: "quantity" },
    { label: "Price", key: "price" },
    { label: "Fee", key: "organizerfees" },
    { label: "Date", key: "date" },
    { label: "Event Date", key: "eventdate" },
    { label: "Payment Id", key: "payment_id" },
];


const csvData = filteredTransactions.map((transaction) => {

  const formatDateTime = (date) => {
      if (!date) return "-";
      const d = new Date(date);
      return d.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
      });
    };

    return {
      phone: `${transaction.phone}`,
      resellerPhone: `${transaction.reseller_phone}`,
        name: transaction.name,
        duration: transaction.duration + " day",
        ticket_type: transaction.type,
        quantity: transaction.quantity,
        price: transaction.price,
        organizerfees: transaction.organizerfees,
        date: formatDateTime(transaction.created_at),
        eventdate: transaction.duration == "1" ? formatDateTime(transaction.event_ticket_date) : formatDateTime(transaction.start_datetime),
        payment_id: transaction.payment_id,
    };
  });

  return (
    <Fragment>
      <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        <h2 className='text-black font-w600 mb-0'>Secondary Transaction</h2>
        {/* <CSVLink data={csvData} headers={csvHeaders} filename={"transactions.csv"}>
                      <Button variant="primary">Download CSV</Button>
                  </CSVLink> */}
      </div>

      {/* Search input */}
      <div className='mb-4 d-sm-flex d-block justify-content-end'>
      <div style={{ position: "relative", width: "18rem" }}>
  <Form.Control
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    style={{
      width: "100%",
      fontSize: "18px",
      fontWeight: 500,
      paddingRight: "2rem",
      borderRadius:'0.625rem',
      height:'3.2rem' // Add padding to ensure the icon doesn't overlap text
    }}
  />

  <i
    className="fa fa-search"
    style={{
      position: "absolute",
      right: "10px", // Distance from the right edge of the input
      top: "50%",
      transform: "translateY(-50%)", // Center vertically
      color: "#6c757d", // Optional: color for the icon
      pointerEvents: "none", // Makes sure clicks pass through to the input
    }}
  ></i>

</div>

      </div>

      <Card>
        <Card.Body>
          {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading...</p>
                </div>) : 
          (<DataTable
            columns={columns}
            data={filteredTransactions} // Use filtered data
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />)}
        </Card.Body>
      </Card>

    </Fragment>
  );
};

export default SecondaryMarketTransactions;
